module.exports = __webpack_public_path__ + "img/dianzan@2x.4c847c62.png";